/**
 * @chineseName 布局
 * @subDescription m-ui组件 布局
 */
import InternalLayout, { Content, Footer, Header } from './layout';
import Sider from './Sider';
var Layout = InternalLayout;
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Content = Content;
Layout.Sider = Sider;
export default Layout;